export default __webpack_public_path__ + "static/media/ic-arrow-head-up.6fd242e4.svg";